import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 9,
	height: 12,
	viewBox: "0 0 9 12",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.0564 1L7 5.97635L1 11",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgChevronRight;
